/** @format */
import { useEffect, useState } from 'react';

export function useLocalStorage(key: string, initialValue: any) {
    /*
     * State to store our value
     * Pass initial state function to useState so logic is only executed once
     */
    const [storedValue, setStoredValue] = useState(initialValue);

    /**
     * Return a wrapped version of useState's setter function that
     * persists the new value to localStorage.
     */
    const setValue = (value: any) => {
        // Allow value to be a function so we have same API as useState
        const valueToStore =
            value instanceof Function ? value(storedValue) : value;
        // Save state
        setStoredValue(valueToStore);
        // Save to local storage
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
    };

    useEffect(() => {
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            if (item) {
                // Parse stored json or if none return initialValue
                setStoredValue(JSON.parse(item));
            }
        } catch (error) {
            console.error(error);
        }
    }, []);

    return [storedValue, setValue];
}
